import React, { useContext, useEffect, useState } from "react";
import { useAuth } from "./Auth";
import { toast } from "react-toastify";
import { logoutUser } from "../utils/helpers";
// import { notifications } from "./data"

const appContext = React.createContext();

const Context = ({ children }) => {
  const { requestWithAuth } = useAuth();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isLiveLocationOpen, setIsLiveLocationOpen] = useState(false);
  const [activeSession, setActiveSession] = useState(null);
  const [isLoadingSession, setIsLoadingSession] = useState(true);
  const [company, setCompany] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);
  const [systemSetting, setSystemSetting] = useState(null);
  const [priceUpdateAvailable, setPriceUpdateAvailable] = useState(false);
  //   const [notification, setNotification] = useState(false)
  //   const [noticationMessages, setNotificationMessages] = useState(notifications)
  const [hasRequestedOTP, setHasRequestedOTP] = useState(false);
  const [isEmailVerified, setIsEmailVerified] = useState(() => {
    return (
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("isEmailVerified="))
        ?.split("=")[1] === "true"
    );
  });

  const isAuthenticated = () => {
    return !!document.cookie
      .split("; ")
      .find((row) => row.startsWith("activesession="));
  };

  const openSidebar = () => {
    setIsSidebarOpen(true);
  };

  const updateEmailVerificationStatus = (status) => {
    document.cookie = `isEmailVerified=${status}; path=/; max-age=3600`;
    setIsEmailVerified(status);
  };

  const getActiveSession = async () => {
    try {
      setIsLoadingSession(true);
      const data = await requestWithAuth(`/users/session/active/`, "GET");
      setActiveSession(data);
    } catch (error) {
      setActiveSession(null);
      console.error("Error fetching users data:", error);
    } finally {
      setIsLoadingSession(false);
    }
  };

  const getSystemSetting = async () => {
    try {
      const data = await requestWithAuth(`/system/settings/`, "GET");
      setSystemSetting(data);
    } catch (error) {
      console.error("Error fetching system setting:", error);
    }
  };

  const getCurrentUser = async () => {
    try {
      const data = await requestWithAuth(`/users/me/`, "GET");
      setCurrentUser(data);
    } catch (error) {
      console.error("Error fetching users data:", error);
    }
  };

  const getCompanyDetails = async () => {
    try {
      const data = await requestWithAuth(`/company/details/`, "GET");
      setCompany(data);
    } catch (error) {
      console.error("Error fetching users data:", error);
    } finally {
    }
  };

  const checkLastInventoryUpdateForUser = async () => {
    try {
      const userData = await requestWithAuth(
        "/users/last-inventory-downloaded/",
        "GET"
      );

      const latestPriceUpdate = systemSetting?.find(
        (s) => s.key === "latest_price_update"
      )?.value;

      // If system setting is missing, nothing to compare → stop
      if (!latestPriceUpdate) return;

      const lastDownloaded = userData?.last_downloaded;

      // Show message if user never downloaded before
      if (!lastDownloaded) {
        setPriceUpdateAvailable(true);
        return;
      }

      // Show message if user's last download is older
      if (new Date(lastDownloaded) < new Date(latestPriceUpdate)) {
        setPriceUpdateAvailable(true);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  useEffect(() => {
    getSystemSetting();
    getActiveSession();
    getCompanyDetails();
    getCurrentUser();
  }, []);

  useEffect(() => {
    if (systemSetting && currentUser) {
      if (currentUser?.role == "dispenser" || currentUser?.role == "branch_manager") {
        checkLastInventoryUpdateForUser();
      }
    }
  }, [systemSetting, currentUser]);

  return (
    <appContext.Provider
      value={{
        isSidebarOpen,
        openSidebar,
        setIsSidebarOpen,
        isLiveLocationOpen,
        setIsLiveLocationOpen,
        // notification,
        // setNotification,
        // toggleNotification,
        // noticationMessages,
        // setNotificationMessages,
        priceUpdateAvailable,
        activeSession,
        currentUser,
        isAuthenticated,
        isLoadingSession,
        isEmailVerified,
        updateEmailVerificationStatus,
        hasRequestedOTP,
        setHasRequestedOTP,
        company,
      }}
    >
      {children}
    </appContext.Provider>
  );
};

const useGlobalContext = () => {
  return useContext(appContext);
};

export { Context, useGlobalContext };